import usePlacesWidget from "dependencies/react-google-autocomplete"
import { defaultFormFields, findComp } from "helpers/address"

export const useGoogleAutocomplete = ({
  country,
  enableCountryCheck = false,
  formFields = defaultFormFields,
  formProps,
  onPlaceSelected,
  ...rest
}) => {
  if (enableCountryCheck && !["US", "CA", "AU"].includes(country)) {
    return {}
  }

  const { setRef } = usePlacesWidget({
    apiKey: sl.api.google_maps?.api_key,
    onPlaceSelected:
      // Use onPlaceSelected function if given;
      // Otherwise, construct said function with formFields & formProps
      onPlaceSelected || getOnPlaceSelected(formFields, formProps),
    options: {
      componentRestrictions: { country },
      types: ["address"],
    },
    ...rest,
  })

  return { setRef }
}

export const getOnPlaceSelected = (formFields, formProps) => (place) => {
  const components = place.address_components
  const original_address1 = formProps.getFieldProps(formFields.address1).value
  // Address 1
  const street_number = findComp("street_number", components)
  let street_addr = ""
  if (!street_number) {
    // NOTE: hack to manually fetch street number since google autocomplete sometimes cuts it out
    street_addr = original_address1.split(",")[0]
  } else {
    street_addr = `${street_number} ${findComp("route", components)}`
  }
  street_addr = street_addr.trim()
  formProps.setFieldValue(formFields.address1, street_addr)

  // City
  // We will try to match city to one shown in auto-complete suggestion (which is returned in
  // formatted_address)
  let formatted_address = place.formatted_address
  let gm_city = ""

  // City value can be any one of these four options
  let locality = findComp("locality", components)
  let neighborhood = findComp("neighborhood", components)
  let sublocality = findComp("sublocality", components)
  let postal_town = findComp("postal_town", components)

  if (neighborhood != "" && formatted_address.includes(neighborhood)) {
    gm_city = neighborhood
  } else if (sublocality != "" && formatted_address.includes(sublocality)) {
    gm_city = sublocality
  } else if (postal_town && formatted_address.includes(postal_town)) {
    gm_city = postal_town
  } else {
    gm_city = locality
  }
  // TEMP fix for 1536 Heritage Links, Wake Forest, NC
  if (gm_city == "Heritage") gm_city = "Wake Forest"
  if (gm_city) {
    formProps.setFieldValue(formFields.city, gm_city)
  }

  // State
  const gm_state = findComp("administrative_area_level_1", components)
  if (gm_state) {
    formProps.setFieldValue(formFields.state, gm_state)
  }

  // Update postal code
  const gm_postal_code = findComp("postal_code", components)
  if (gm_postal_code) {
    formProps.setFieldValue(formFields.postal_code, gm_postal_code)
  }

  // Update address2
  const gm_address2 = findComp("subpremise", components)
  if (gm_address2) {
    formProps.setFieldValue(formFields.address2, gm_address2)
  } else if (
    findComp("country", components) === "Canada" &&
    original_address1.split(" ")[0].includes("-")
  ) {
    const array_chunk = original_address1.split(" ")[0].split("-")
    formProps.setFieldValue(formFields.address2, array_chunk[0])
  }

  return false
}
